import { styled, FormControlLabel } from "@mui/material";
const ToggleFormControlLabel = styled(FormControlLabel)(({ theme, error }) => ({
  marginLeft: 0,
  justifyContent: "space-between",
  width: "100%",
  color: error ? theme.palette.error[500] : "currentColor",
  ...theme.typography["Lato Caption"]
}));
export {
  ToggleFormControlLabel
};
